import axiosInstance from '../Api/axiosInstance';

// Get a single client by ID
export const getClient = (id) => axiosInstance.get(`/clients/${id}`);

// Create a new client
export const createClient = (clientData) =>
	axiosInstance.post('/clients', clientData);

// Update an existing client by ID
export const updateClient = (id, clientData) =>
	axiosInstance.put(`/clients/${id}`, clientData);

// Delete a client by ID
export const deleteClient = (id) => axiosInstance.delete(`/clients/${id}`);

// Get all clients for a specific company
// Note: companyId is automatically added by axios interceptor, so we don't need to pass it manually
export const getClients = (companyId) => axiosInstance.get(`/clients`);

// Get invoices for a specific client by ID
export const getInvoicesForClient = (clientId) =>
	axiosInstance.get(`/clients/${clientId}/invoices`);

// Note: Logo upload now happens directly to Uploadthing via UploadthingWidget on frontend
// The companyLogo URL is saved when client is created/updated
